<template>
  <header 
    class="header" 
    :class="{ 'header-hidden': !showHeader }"
  >
    <div class="header-left">
      <div class="logo-icon" @click="rt.push('/')">
        <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.8695 15.9484L12.8726 19H4.12735L1.13049 15.9699V4.27015H0V0H7.41217V4.27015H6.29235V14.126L6.90025 14.7191H10.1211L10.7077 14.126V4.27015H9.58783V0H17V4.27015H15.8695V15.9484Z" fill="#fff"></path>
        </svg>
      </div>
      <button 
        class="burger" 
        @click="headMenu = true"
        aria-label="Меню"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
    
    <div class="header-right">
      <button 
        class="icon-btn theme-toggle" 
        @click="toggleTheme"
        :aria-label="isDarkTheme ? 'Светлая тема' : 'Темная тема'"
      >
        <svg v-if="isDarkTheme" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="5"/>
          <path d="M12 2V4M12 20V22M4 12H2M20 12H22M19.07 4.93L17.66 6.34M6.34 17.66L4.93 19.07M19.07 19.07L17.66 17.66M6.34 6.34L4.93 4.93" stroke="currentColor" stroke-linecap="round"/>
        </svg>
        <svg v-else width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" stroke="currentColor" fill="none"/>
        </svg>
      </button>
      
      <button class="icon-btn" aria-label="Уведомления">
        <sse />
      </button>
      
      <button class="icon-btn" aria-label="Корзина" @click="viewBasket()" v-if="['junior-manager','club-manager','club-owner'].includes(role)">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 10V8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8V10" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
          <rect x="5" y="10" width="14" height="10" rx="2" stroke="currentColor" stroke-width="1.4"/>
          <circle cx="12" cy="16" r="1.5" fill="currentColor" stroke="none"/>
        </svg>
        <span class="countproduct">{{ basket.length }}</span>
      </button>
    </div>
  </header>

  <transition name="slimeright">
    <slotokno :close="() => headMenu = false" :text="'Меню'" v-if="headMenu">
      <headermenu />
    </slotokno>
  </transition>
</template>

<script setup>
import headermenu from './headermenu.vue'
import { useTheme } from '@/composables/useTheme'
import { ref, onMounted, onUnmounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { client, activity, viewUser, oknoUser } from '@/controlles/client'
import { basket, viewbasket } from '@/controlles/basket/basket'
import { headMenu,notSet } from '@/controlles/general'
import sse from '@/components/general/sse.vue'
import { role,sklad1c } from '@/controlles/auth'


const viewBasket = () => {
  if(['club-owner','club-manager'].includes(role.value)){
    return viewbasket.value = true
  }

  if(!activity.value){
    if(sklad1c.value == '2-Готовая продукция'){
       return viewbasket.value = true
    }
    return notSet('Авторизуйте пользователя')

  }
   return viewbasket.value = true

}


const r = useRoute()
const rt = useRouter()
const { isDarkTheme, toggleTheme } = useTheme()

const showHeader = ref(true)
let lastScrollY = 0
let scrollTimer = null

const handleScroll = () => {
  const currentScrollY = window.scrollY
  if (currentScrollY > lastScrollY && currentScrollY > 100) {
    showHeader.value = false
  } else if (currentScrollY < lastScrollY) {
    showHeader.value = true
  }
  
  lastScrollY = currentScrollY
}
const throttleScroll = () => {
  if (!scrollTimer) {
    scrollTimer = setTimeout(() => {
      handleScroll()
      scrollTimer = null
    }, 100)
  }
}

onMounted(() => {
  window.addEventListener('scroll', throttleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', throttleScroll)
  if (scrollTimer) {
    clearTimeout(scrollTimer)
  }
})

watch([r], () => {
  if (headMenu.value == true) { 
    headMenu.value = false 
  }
  showHeader.value = true
  lastScrollY = window.scrollY
})
</script>

<style scoped>


.header {
    height: 61px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    background: var(--header-bg);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-bottom: 1px solid var(--header-border);
    position: fixed;
    top: 0;
    transition: background 0.3s, border-color 0.3s;
    width: 100%;
    margin: 0 auto;
   
    transition: transform 0.3s ease;
    z-index: 1000;
}

.header-hidden {
  transform: translateY(-100%);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--accent-black);
  border-radius: 100%;
  transition: background-color 0.3s;
}

html.dark .logo-icon {
  background-color: var(--action-btn-bg);  /* #f0f0f0 в темной теме */
}

.burger {
  width: 22px;
  height: 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  position: relative;
  z-index: 30;
}

.burger span {
  width: 100%;
  height: 2px;
  background-color: var(--text-primary);
  border-radius: 3px;
  transition: transform 0.2s, opacity 0.2s, background-color 0.3s;
}

.burger.open span:nth-child(1) {
  transform: translateY(8px) rotate(45deg);
}

.burger.open span:nth-child(2) {
  opacity: 0;
}

.burger.open span:nth-child(3) {
  transform: translateY(-8px) rotate(-45deg);
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--icon-btn-hover);
  transition: background-color 0.2s;
  cursor: pointer;
  position: relative;
  border: none;
  color: var(--text-primary);
}

.icon-btn:hover {
  background-color: var(--icon-btn-hover);
}

.theme-toggle {
  font-size: 0;
}

.badge {
  position: absolute;
  top: 4px;
  right: 4px;
  background-color: var(--badge-bg);
  color: var(--badge-text);
  font-size: 10px;
  font-weight: 600;
  min-width: 18px;
  height: 18px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  border: 2px solid var(--badge-border);
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
}

.icon-btn svg {
  stroke: currentColor;
}

.icon-btn svg circle[fill] {
  fill: currentColor;
}
.countproduct{
    position: absolute;
    z-index: 1;
    top: 0;
    right: 4px;
    font-weight: 500;
}
</style>